/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AuthUserPinRequest } from '../../models/auth-user-pin-request';
import { AuthUserPinResponse } from '../../models/auth-user-pin-response';

export interface AuthUserPin$Params {

/**
 * uuid key of the tenant
 */
  'X-Tenant-Key'?: string;
      body: AuthUserPinRequest
}

export function authUserPin(http: HttpClient, rootUrl: string, params: AuthUserPin$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthUserPinResponse>> {
  const rb = new RequestBuilder(rootUrl, authUserPin.PATH, 'post');
  if (params) {
    rb.header('X-Tenant-Key', params['X-Tenant-Key'], {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AuthUserPinResponse>;
    })
  );
}

authUserPin.PATH = '/api/v1/auth/user/pin';
